import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const numberFormat = new Intl.NumberFormat("id-ID");
const numberFormatYen = new Intl.NumberFormat('jp-JP', {
  style: 'currency',
  currency: 'JPY',
  maximumFractionDigits: 0
})

const numberFormatDollar = new Intl.NumberFormat('us-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0
})

export function formatRupiah(number: number) {
  return "Rp " + numberFormat.format(number);
}

export function formatYen(number: number) {
  return numberFormatYen.format(number)
}

export function formatDollar(number: number) {
  return numberFormatDollar.format(number)
}

export function asset(path: string) {
  return `${process.env.NEXT_PUBLIC_CORE_BASEURL}/${path}`;
}
